<div
  cdkDrag
  [cdkDragDisabled]="dragDisabled"
  class="translateCDK not-see-through"
  id="camera-{{ camera.id }}"
  [ngStyle]="style"
  mwlResizable
  [validateResize]="validate"
  [enableGhostResize]="true"
  [resizeSnapGrid]="{ left: 50, right: 50, top: 50, bottom: 50 }"
  (resizeEnd)="onResizeEnd($event)"
>
  <div style="position: relative">
    <ng-container *ngIf="dragControls">
      <div
        *ngIf="!unlockButton"
        class="resize-handle-left"
        mwlResizeHandle
        [resizeEdges]="{ left: true, top: true, bottom: true }"
      ></div>
      <div
        *ngIf="!unlockButton"
        class="resize-handle-right"
        mwlResizeHandle
        [resizeEdges]="{ right: true, top: true, bottom: true }"
      ></div>
      <sn-fab-button
        (mouseover)="detect()"
        (mouseout)="detect()"
        class="close"
        [matTooltip]="'common.closeCamera' | t"
        (click)="removeCamera()"
      >
        <sn-icon>close</sn-icon>
      </sn-fab-button>

      <sn-fab-button *ngIf="!unlockButton" cdkDragHandle class="drag-handle">
        <sn-icon>open_with</sn-icon>
      </sn-fab-button>

      <sn-fab-button
        [disabled]="unlockDisabled"
        *ngIf="unlockButton"
        class="unlock-camera"
        [matTooltip]="'map.camera.tooltips.unlockCamera' | t"
        (click)="unLock()"
      >
        <sn-icon>lock_open</sn-icon>
      </sn-fab-button>

      <sn-fab-button
        *ngIf="!unlockButton"
        class="unlock-camera"
        [matTooltip]="'map.camera.tooltips.lockCamera' | t"
        (click)="lockCam()"
      >
        <sn-icon>lock</sn-icon>
      </sn-fab-button>
    </ng-container>

    <ng-container *ngIf="allowPlayback">
      <sn-fab-button
        [disabled]="playbackDisabled"
        *ngIf="playback && !isUnmanaged"
        class="playback"
        [matTooltip]="'map.camera.tooltips.viewPlayback' | t"
        (click)="viewCamPlayback()"
      >
        <sn-icon>update</sn-icon>
      </sn-fab-button>
    </ng-container>

    <sn-audit-camera-stream-view
      *ngIf="!camera.isAxonCamera"
      #auditCameraStream
      (mouseover)="onMouseOver()"
      (mouseout)="onMouseOut()"
      matCardImage
      [alwaysOn]="alwaysOn"
      [autoplay]="true"
      [camera]="camera"
      [controls]="true"
      [actions]="actions"
      [canEdit]="canChange && camera.isOwned"
    >
    </sn-audit-camera-stream-view>
  </div>
</div>
